<template>
	<div class="head-tabs" v-if="data">
		<span :class="{'active': tabstate[i]}" @click="change(i)" v-for="(m,i) in data" :key="m.id">{{m}}</span>
	</div>
</template>

<script>
	export default {
		name: 'ep-tabs',
		data() {
			return {
				data: [],
				tabstate: []
			}
		},
		props: {
			config: {
				type: Array,
				default() {
					return ['标签一', '标签二']
				}
			}
		},
		created() {
			this.initState(this.config)
			this.data = this.config
		},
		methods: {
			// 初始化状态
			initState(val) {
				let state = []
				if(val.length > 0) {
					for(let m in val) {
						if(m == 0) {
							state.push(true)
						} else {
							state.push(false)
						}
					}
					this.tabstate = state
				}
			},
			// 切换标签页
			change(num) {
				let changeState = JSON.parse(JSON.stringify(this.tabstate))
				for(let m in changeState) {
					changeState[m] = false
				}
				changeState[num] = true
				this.tabstate = changeState
				this.$emit('change', num)
			}
		}
	}
</script>

<style scoped>
	.head-tabs {
		height: 40px;
		width: 100%;
		border-bottom: 1px solid #eeeeee;
		line-height: 40px;
		text-align: left;
	}
	
	.head-tabs span {
		padding: 10px;
		margin-right: 10px;
		cursor: pointer;
		font-size: 14px;
		text-align: center;
		position: relative;
		transition: all .3s ease-in-out;
	}
	
	.head-tabs span:after {
		content: '';
		position: absolute;
		width: 1px;
		height: 2px;
		bottom: 0;
		left: 50%;
		background: #369eff;
		opacity: 0;
		transition: all .3s ease-in-out;
	}
	
	.head-tabs span:hover:after {
		width: 100%;
		left: 0;
		opacity: 1;
	}
	
	.head-tabs .active {
		color: #369eff;
	}
	
	.head-tabs .active:after {
		width: 100%;
		left: 0;
		opacity: 1;
	}
</style>


// WEBPACK FOOTER //
// Tabs.vue?6b4028f0